import { useState } from "react";
import Dashboard from "./pages/Dashboard";
import SearchResults from "./pages/SearchResults";

function App() {
  const [view, setView] = useState("chat"); // "chat" | "search"
  const [searchFilters, setSearchFilters] = useState(null);

  const openSearch = (filters) => {
    setSearchFilters(filters);
    setView("search");
  };

  const backToChat = () => {
    setView("chat");
  };

  return (
    <>
      <div style={{ display: view === "chat" ? "block" : "none", height: "100vh" }}>
        <Dashboard onOpenSearch={openSearch} />
      </div>
      {view === "search" && searchFilters && (
        <div style={{ height: "100vh" }}>
          <SearchResults filters={searchFilters} onBack={backToChat} />
        </div>
      )}
    </>
  );
}

export default App;